export default __webpack_public_path__ + "static/media/vFetch.0d5a3cb4.png";